import html2canvas from "html2canvas";

export class WaterMarkCanvas {
  static CANVAS_WIDTH = 1600;
  static CANVAS_HEIGHT = 900;

  static setStyle = function(ele, style) {
    if (!ele || !ele.style) return;
    for (var styleKey in style) {
      if (style.hasOwnProperty(styleKey)) {
        ele.style[styleKey] = style[styleKey];
      }
    }
  };
  static setWAH = function(ele, width, height) {
    if (!ele) return;
    ele.width = width;
    ele.height = height;
    ele.style.width = width + "px";
    ele.style.height = height + "px";
  };
  static wait = function(getEle, func, times, interval) {
    if (typeof getEle !== "function") return;
    var _times = times || -1, //100婵炲棴鎷�
      _interval = interval || 20, //20婵綆鍋嗛～妤€袙韫囨棏鍋�
      _self = this,
      _iIntervalID; //閻庤纰嶅鍌炲闯閳侯櫔
    if (getEle()) {
      //濠碘€冲€归悘澶婎啅閼碱剛鐥呴柤鎯у槻瑜板洭宕氭０浣哄晩闁挎稑鑻銊╂儎鐎涙ê澶嶉柟绗涘棭鏀介柛鎴ｅГ閺嗭拷
      func && func.call(this);
    } else {
      _iIntervalID = setInterval(function() {
        if (!_times) {
          //闁哄嫸鎷�0閻忓繘浜堕埀顑藉亾闁告埊鎷�
          clearInterval(_iIntervalID);
        }
        _times <= 0 || _times--; //濠碘€冲€归悘澶愬及椤栨侗鍔€闁轰焦婢樺锟� --

        if (getEle()) {
          // 闁告劕绉甸濂告焻婢跺顏�,闁告帇鍊栭弻鍥及椤栨碍鍎婇柛娆愮墪閸╋拷
          func && func.call(_self);
          clearInterval(_iIntervalID);
        }
      }, _interval);
    }
    return this;
  };

  constructor(options) {
    this.wmId = "wea_watremark_" + parseInt(Math.random() * 1000);
    this.options = options;
    this.cache = {};
  }

  // 缂備焦锚閸╂anvas闁哄秴鍢茬槐锟�
  drawCanvas = () => {
    //Draw canvas
    var canvas = document.createElement("canvas");
    canvas.style.width = WaterMarkCanvas.CANVAS_WIDTH + "px";
    canvas.style.height = WaterMarkCanvas.CANVAS_HEIGHT + "px";
    canvas.width = WaterMarkCanvas.CANVAS_WIDTH;
    canvas.height = WaterMarkCanvas.CANVAS_HEIGHT;
    canvas.id = this.wmId;
    canvas.style.display = "block";
    canvas.style.pointerEvents = "none";
    canvas.style.position = "fixed";
    canvas.style.zIndex = 99999;
    canvas.style.top = 0;
    canvas.style.left = 0;
    canvas.style.textAlign = "center";
    return canvas;
  };
  // 缂備焦锚閸╂寮崶銊︽嫳婵ɑ娼欏畵锟�
  drawTextWatermark = options => {
    var windowWidth = window.innerWidth;
    var windowHeight = window.innerHeight;
    var canvas = this.drawCanvas();
    var ctx = canvas.getContext("2d");
    ctx.clearRect(
      0,
      0,
      WaterMarkCanvas.CANVAS_WIDTH,
      WaterMarkCanvas.CANVAS_HEIGHT
    );
    ctx.save();
    ctx.scale(
      WaterMarkCanvas.CANVAS_WIDTH / windowWidth,
      WaterMarkCanvas.CANVAS_HEIGHT / windowHeight
    );
    var width = this.options.width > 0 ? this.options.width : 200;
    var height = this.options.height > 0 ? this.options.height : 150;
    var rotate = ((this.options.rotate || 0) / 360) * Math.PI;
    var text = this.options.text;
    var w = WaterMarkCanvas.CANVAS_WIDTH;
    var h = WaterMarkCanvas.CANVAS_HEIGHT;

    var x = Math.ceil(w / width);
    var y = Math.ceil(h / height);

    ctx.textAlign = "center";
    // ctx.font= 'px yahei';
    ctx.globalAlpha = this.options.alpha;
    ctx.rotate(rotate);
    for (var i = 0; i < x; i += 1) {
      for (var j = 0; j < y; j += 1) {
        ctx.fillText(text, i * width, j * height, width);
      }
    }
    ctx.restore();
    document.body.appendChild(canvas);
  };
  // 閻忓繐妫欑€垫氨鈧鐡皁m闁稿繐鍟扮粈锟�闁汇垻鍠愰崹姝漚nvas闁搞儱澧芥晶锟�
  loadWatermarkWithCanvas = (watermarkContentId, layout, callback) => {
    console.time("canvas wm wait dom load");
    layout = layout || document;
    WaterMarkCanvas.wait(
      () => {
        return layout.getElementById(watermarkContentId);
      },
      () => {
        console.timeEnd("canvas wm wait dom load");
        console.time("canvas wm wait html to canvas");
        var getPixelRatio = function(context) {
          // 闁兼儳鍢茶ぐ鍥╂媼閹屾У闁汇劌鍤xelRatio
          var backingStore =
            context.backingStorePixelRatio ||
            context.webkitBackingStorePixelRatio ||
            context.mozBackingStorePixelRatio ||
            context.msBackingStorePixelRatio ||
            context.oBackingStorePixelRatio ||
            context.backingStorePixelRatio ||
            1;
          return (window.devicePixelRatio || 1) / backingStore;
        };
        var shareContent = layout.getElementById(watermarkContentId);
        var width = shareContent.offsetWidth;
        var height = shareContent.offsetHeight;
        var canvas = document.createElement("canvas");
        var context = canvas.getContext("2d");
        // 閻忓繐鎽禷nvas闁汇劌瀚鎰板闯閵婏箑鈷栧棰濇箳ixelRatio闁稿﹤绋勭槐婵嬪礃瀹ュ懐娈洪柣銏ｎ嚙缁旈绱撻埡鍌涙澒闁挎稑鑻惃銏ゅ炊閹冨壖闁衡偓閹佷海PixelRatio闁稿﹤绋勭槐婵嬫⒓閸欏鍓鹃悗鐢靛帶閸ゎ參鎯冮崟顐ｇ闁绘娲﹁啯缂侇垽鎷�
        var scale = getPixelRatio(context);
        context.scale(scale, scale);
        WaterMarkCanvas.setWAH(canvas, width * scale, height * scale);
        var opts = {
          backgroundColor: null,
          scale: scale,
          canvas: canvas,
          width: width,
          height: height,
          useCORS: true,
          dpi: window.devicePixelRatio,
          ignoreElements: element => {
            /* 鏉╁洦鎶ら崶鍓у娑撳娴囬幓鎺嶆閻ㄥ埇frame閿涘矂妲诲銏犳禈閻楀洭鍣告径宥勭瑓鏉炰粙妫舵０锟� */
            if (element.id == "downloadFrame") {
              return true;
            }
            /* 去除非水印的图片元素，防止验证码图片重复请求 */
            if (
              element.tagName === "IMG" &&
              element.className !== "wea_watremark_img"
            ) {
              return true;
            }
            if (element.nodeName === "IFRAME") {
              /* 过滤 EMobile 聊天工具 */
              if (element.className === "eMobile-iframe") {
                return true;
              }
              /* 过滤iframe的src中带接口的，一般为下载工具 */
              if (element.src && /\/api\//.test(element.src)) {
                return true;
              }
            }
          }
        };
        html2canvas(shareContent, opts).then(canvas => {
          console.timeEnd("canvas wm wait html to canvas");
          this.canvas = canvas;
          var context = canvas.getContext("2d");
          // 闁稿繑濞婂Λ鎾箮濡ゅ懏鏆滃璇茬仢閼革拷
          context.mozImageSmoothingEnabled = false;
          context.webkitImageSmoothingEnabled = false;
          context.msImageSmoothingEnabled = false;
          context.imageSmoothingEnabled = false;
          this.cache.width = width;
          this.cache.height = height;
          this.cache.scale = scale;
          this.loadWatermarkToImage(canvas, callback);
        });
      }
    );
  };
  loadWatermarkToImage = (canvas, callback) => {
    console.time("canvas wm canvas to image");
    canvas = canvas || this.canvas;
    // canvas閺夌儐鍓欑€靛弶绋夐崫鍕闁绘鎷�
    var newImg = Canvas2Image.convertToImage(canvas);
    // 缂備焦鐟ュù姗€鎮ч崶顏嶅晭缂傚喚鍠栫敮顐ｆ叏鐎ｎ剚鐣遍悗閫涚矙閻濓拷
    newImg.style.all = "initial";
    WaterMarkCanvas.setWAH(newImg, this.cache.width, this.cache.height);
    WaterMarkCanvas.setStyle(newImg, {
      display: "block",
      pointerEvents: "none",
      textAlign: "center",
      position: "fixed",
      zIndex: 99999,
      top: 0,
      left: 0
    });
    console.timeEnd("canvas wm canvas to image");
    if (callback) callback(newImg, canvas);
  };
}

/**
 * covert canvas to image
 * and save the image file
 */
export var Canvas2Image = (function() {
  // check if support sth.
  var $support = (function() {
    var canvas = document.createElement("canvas"),
      ctx = canvas.getContext("2d");

    return {
      canvas: !!ctx,
      imageData: !!ctx.getImageData,
      dataURL: !!canvas.toDataURL,
      btoa: !!window.btoa
    };
  })();

  var downloadMime = "image/octet-stream";

  function scaleCanvas(canvas, width, height) {
    var w = canvas.width,
      h = canvas.height;
    if (width == undefined) {
      width = w;
    }
    if (height == undefined) {
      height = h;
    }

    var retCanvas = document.createElement("canvas");
    var retCtx = retCanvas.getContext("2d");
    retCanvas.width = width;
    retCanvas.height = height;
    retCtx.drawImage(canvas, 0, 0, w, h, 0, 0, width, height);
    return retCanvas;
  }

  function getDataURL(canvas, type, width, height) {
    canvas = scaleCanvas(canvas, width, height);
    return canvas.toDataURL(type);
  }

  function saveFile(strData) {
    document.location.href = strData;
  }

  function genImage(strData) {
    var img = document.createElement("img");
    img.src = strData;
    return img;
  }
  function fixType(type) {
    type = type.toLowerCase().replace(/jpg/i, "jpeg");
    var r = type.match(/png|jpeg|bmp|gif/)[0];
    return "image/" + r;
  }
  function encodeData(data) {
    if (!window.btoa) {
      throw "btoa undefined";
    }
    var str = "";
    if (typeof data == "string") {
      str = data;
    } else {
      for (var i = 0; i < data.length; i++) {
        str += String.fromCharCode(data[i]);
      }
    }

    return btoa(str);
  }
  function getImageData(canvas) {
    var w = canvas.width,
      h = canvas.height;
    return canvas.getContext("2d").getImageData(0, 0, w, h);
  }
  function makeURI(strData, type) {
    return "data:" + type + ";base64," + strData;
  }

  /**
   * create bitmap image
   * 闂佸湱枪椤﹂亶宕ｆ惔锝嗗枂闁告洦鍋勯悘鐔兼煟閵忋垹鏋戦柛銊﹀哺瀹曞爼宕滆椤ｅ鏌涘┑鍡櫺㈢紒銊ュ级瀵板嫰寮堕幋鐐差伅闂佸憡绻傜粔瀵歌姳閸欏濯撮柨鐕傛嫹
   */
  var genBitmapImage = function(oData) {
    //
    // BITMAPFILEHEADER: http://msdn.microsoft.com/en-us/library/windows/desktop/dd183374(v=vs.85).aspx
    // BITMAPINFOHEADER: http://msdn.microsoft.com/en-us/library/dd183376.aspx
    //

    var biWidth = oData.width;
    var biHeight = oData.height;
    var biSizeImage = biWidth * biHeight * 3;
    var bfSize = biSizeImage + 54; // total header size = 54 bytes

    //
    //  typedef struct tagBITMAPFILEHEADER {
    //  	WORD bfType;
    //  	DWORD bfSize;
    //  	WORD bfReserved1;
    //  	WORD bfReserved2;
    //  	DWORD bfOffBits;
    //  } BITMAPFILEHEADER;
    //
    var BITMAPFILEHEADER = [
      // WORD bfType -- The file type signature; must be "BM"
      0x42,
      0x4d,
      // DWORD bfSize -- The size, in bytes, of the bitmap file
      bfSize & 0xff,
      (bfSize >> 8) & 0xff,
      (bfSize >> 16) & 0xff,
      (bfSize >> 24) & 0xff,
      // WORD bfReserved1 -- Reserved; must be zero
      0,
      0,
      // WORD bfReserved2 -- Reserved; must be zero
      0,
      0,
      // DWORD bfOffBits -- The offset, in bytes, from the beginning of the BITMAPFILEHEADER structure to the bitmap bits.
      54,
      0,
      0,
      0
    ];

    //
    //  typedef struct tagBITMAPINFOHEADER {
    //  	DWORD biSize;
    //  	LONG  biWidth;
    //  	LONG  biHeight;
    //  	WORD  biPlanes;
    //  	WORD  biBitCount;
    //  	DWORD biCompression;
    //  	DWORD biSizeImage;
    //  	LONG  biXPelsPerMeter;
    //  	LONG  biYPelsPerMeter;
    //  	DWORD biClrUsed;
    //  	DWORD biClrImportant;
    //  } BITMAPINFOHEADER, *PBITMAPINFOHEADER;
    //
    var BITMAPINFOHEADER = [
      // DWORD biSize -- The number of bytes required by the structure
      40,
      0,
      0,
      0,
      // LONG biWidth -- The width of the bitmap, in pixels
      biWidth & 0xff,
      (biWidth >> 8) & 0xff,
      (biWidth >> 16) & 0xff,
      (biWidth >> 24) & 0xff,
      // LONG biHeight -- The height of the bitmap, in pixels
      biHeight & 0xff,
      (biHeight >> 8) & 0xff,
      (biHeight >> 16) & 0xff,
      (biHeight >> 24) & 0xff,
      // WORD biPlanes -- The number of planes for the target device. This value must be set to 1
      1,
      0,
      // WORD biBitCount -- The number of bits-per-pixel, 24 bits-per-pixel -- the bitmap
      // has a maximum of 2^24 colors (16777216, Truecolor)
      24,
      0,
      // DWORD biCompression -- The type of compression, BI_RGB (code 0) -- uncompressed
      0,
      0,
      0,
      0,
      // DWORD biSizeImage -- The size, in bytes, of the image. This may be set to zero for BI_RGB bitmaps
      biSizeImage & 0xff,
      (biSizeImage >> 8) & 0xff,
      (biSizeImage >> 16) & 0xff,
      (biSizeImage >> 24) & 0xff,
      // LONG biXPelsPerMeter, unused
      0,
      0,
      0,
      0,
      // LONG biYPelsPerMeter, unused
      0,
      0,
      0,
      0,
      // DWORD biClrUsed, the number of color indexes of palette, unused
      0,
      0,
      0,
      0,
      // DWORD biClrImportant, unused
      0,
      0,
      0,
      0
    ];

    var iPadding = (4 - ((biWidth * 3) % 4)) % 4;

    var aImgData = oData.data;

    var strPixelData = "";
    var biWidth4 = biWidth << 2;
    var y = biHeight;
    var fromCharCode = String.fromCharCode;

    do {
      var iOffsetY = biWidth4 * (y - 1);
      var strPixelRow = "";
      for (var x = 0; x < biWidth; x++) {
        var iOffsetX = x << 2;
        strPixelRow +=
          fromCharCode(aImgData[iOffsetY + iOffsetX + 2]) +
          fromCharCode(aImgData[iOffsetY + iOffsetX + 1]) +
          fromCharCode(aImgData[iOffsetY + iOffsetX]);
      }

      for (var c = 0; c < iPadding; c++) {
        strPixelRow += String.fromCharCode(0);
      }

      strPixelData += strPixelRow;
    } while (--y);

    var strEncoded =
      encodeData(BITMAPFILEHEADER.concat(BITMAPINFOHEADER)) +
      encodeData(strPixelData);

    return strEncoded;
  };

  /**
   * saveAsImage
   * @param canvasElement
   * @param {String} image type
   * @param {Number} [optional] png width
   * @param {Number} [optional] png height
   */
  var saveAsImage = function(canvas, width, height, type) {
    if ($support.canvas && $support.dataURL) {
      if (typeof canvas == "string") {
        canvas = document.getElementById(canvas);
      }
      if (type == undefined) {
        type = "png";
      }
      type = fixType(type);
      if (/bmp/.test(type)) {
        var data = getImageData(scaleCanvas(canvas, width, height));
        var strData = genBitmapImage(data);
        saveFile(makeURI(strData, downloadMime));
      } else {
        var strData = getDataURL(canvas, type, width, height);
        saveFile(strData.replace(type, downloadMime));
      }
    }
  };

  var convertToImage = function(canvas, width, height, type) {
    if ($support.canvas && $support.dataURL) {
      if (typeof canvas == "string") {
        canvas = document.getElementById(canvas);
      }
      if (type == undefined) {
        type = "png";
      }
      type = fixType(type);

      if (/bmp/.test(type)) {
        var data = getImageData(scaleCanvas(canvas, width, height));
        var strData = genBitmapImage(data);
        return genImage(makeURI(strData, "image/bmp"));
      } else {
        var strData = getDataURL(canvas, type, width, height);
        return genImage(strData);
      }
    }
  };

  return {
    saveAsImage: saveAsImage,
    saveAsPNG: function(canvas, width, height) {
      return saveAsImage(canvas, width, height, "png");
    },
    saveAsJPEG: function(canvas, width, height) {
      return saveAsImage(canvas, width, height, "jpeg");
    },
    saveAsGIF: function(canvas, width, height) {
      return saveAsImage(canvas, width, height, "gif");
    },
    saveAsBMP: function(canvas, width, height) {
      return saveAsImage(canvas, width, height, "bmp");
    },

    convertToImage: convertToImage,
    convertToPNG: function(canvas, width, height) {
      return convertToImage(canvas, width, height, "png");
    },
    convertToJPEG: function(canvas, width, height) {
      return convertToImage(canvas, width, height, "jpeg");
    },
    convertToGIF: function(canvas, width, height) {
      return convertToImage(canvas, width, height, "gif");
    },
    convertToBMP: function(canvas, width, height) {
      return convertToImage(canvas, width, height, "bmp");
    }
  };
})();



// WEBPACK FOOTER //
// ./ecology9/wea-tools/html2image.js